import { render, staticRenderFns } from "./LayoutPrintStockMovementReceipt.vue?vue&type=template&id=71158794&"
import script from "./LayoutPrintStockMovementReceipt.vue?vue&type=script&lang=js&"
export * from "./LayoutPrintStockMovementReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports